import {Button, Container, Grid2, useTheme} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import FullScreenModal from "components/common/FullScreenModal";
import {SMALL_DEVICE_MEDIA_SIZE} from "components/common/constants";
import PropTypes from "prop-types";
import React from "react";
import {connect} from "react-redux";
import {Outlet} from "react-router-dom";
import AddAdvertisingForm from "./AddAdvertisingForm";
import "./advHome.scss";
import {AdvertisingList, AdvertisingSearch} from "./index";
import {actions} from "./logic/formActions";
import globalActions from "components/global/logic/actions";

function AdvListViewComponent({ onCloseGlobalSearch, clearForm, globalSearchOpen }) {
    const theme = useTheme();
    const isSmallDevice = useMediaQuery(theme.breakpoints.down(SMALL_DEVICE_MEDIA_SIZE));
    function onClearModal() {
        clearForm();
        onCloseGlobalSearch();
    }
    const btnsModal = (
        <React.Fragment>
            {}
            <Button variant={"contained"} size={"small"} onClick={onClearModal} style={{ marginRight: 5 }}>
                Reset
            </Button>
            <Button variant={"contained"} size={"small"} color={"secondary"} onClick={onCloseGlobalSearch}>
                Search
            </Button>
        </React.Fragment>
    );
    const advSearch = <AdvertisingSearch isSmallDevice={isSmallDevice} />;
    return (
        (<Grid2 container spacing={3}>
            <Grid2
                sx={{ display: {sm: "none", xs: "none", md: "none", xl: "block", lg: "block"}}}
                xlg={3}
                size={{
                    md: 5,
                    lg: 3,
                }}>
                {advSearch}
            </Grid2>
            <FullScreenModal
                btns={btnsModal}
                title={"Filter"}
                handleClose={onCloseGlobalSearch}
                open={globalSearchOpen}
            >
                <Grid2 sx={{ display: {sm: "block", xs: "block", md: "block", xl: "none", lg: "none"}}}>
                    {advSearch}
                </Grid2>
            </FullScreenModal>
            <Grid2
                size={{
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 9,
                    xl: 9
                }}>
                <AdvertisingList />
            </Grid2>
        </Grid2>)
    );
}

function AdvertisingHome({ onCloseGlobalSearch, globalSearchOpen, clearForm, loadStatus }) {
    return (
        <Container maxWidth={"xl"} className={"atsGlobalContainer"}>
            <AddAdvertisingForm />
            <Outlet
                globalSearchOpen={globalSearchOpen}
                clearForm={clearForm}
                loadStatus={loadStatus}
                onCloseGlobalSearch={onCloseGlobalSearch}
            />
        </Container>
    );
}

AdvertisingHome.propTypes = {
    onCloseGlobalSearch: PropTypes.func.isRequired,
    clearForm: PropTypes.func.isRequired,
    advertisingFormOpen: PropTypes.bool.isRequired,
    advertisingFormEditing: PropTypes.bool.isRequired,
    toggleAdvertisingForm: PropTypes.func.isRequired,
    globalSearchOpen: PropTypes.bool.isRequired,
    loadStatus: PropTypes.string.isRequired,
};

export default connect(
    ({ advertising, globalApp }) => ({
        globalSearchOpen: globalApp.globalSearchOpen,
        advertisingFormOpen: advertising.advertisingForm.open,
        loadStatus: advertising.loadStatus,
        advertisingFormEditing: advertising.advertisingForm.editing,
    }),
    (dispatch) => ({
        onCloseGlobalSearch: () => dispatch(globalActions.TOGGLE_GLOBAL_SEARCH_BTN.call(false)),
        clearForm: () => dispatch(actions.CLEAR_FORM.call()),
        toggleAdvertisingForm: () => dispatch(actions.TOGGLE_ADVERTISING_FORM.send()),
    })
)(AdvertisingHome);

export const AdvListView = connect(
    ({ advertising, globalApp }) => ({
        globalSearchOpen: globalApp.globalSearchOpen,
    }),
    (dispatch) => ({
        onCloseGlobalSearch: () => dispatch(globalActions.TOGGLE_GLOBAL_SEARCH_BTN.call(false)),
        clearForm: () => dispatch(actions.CLEAR_FORM.call()),
        toggleAdvertisingForm: () => dispatch(actions.TOGGLE_ADVERTISING_FORM.send()),
    })
)(AdvListViewComponent);
